<template>
    <div class="flex-row c-app align-items-center">
        <CContainer>
            <CRow class="justify-content-center">
                <CCol md="6">
                    <CCardGroup>
                        <CCard class="p-4">
                            <CCardBody>
                                <CForm>
                                    <h1>Вход</h1>
                                    <p class="text-muted pb-2">в панель управления MirCity24.Ru</p>
                                    <CInput
                                        v-model="email"
                                        placeholder="Email"
                                        autocomplete="email"
                                        required
                                        @keyup.enter="login"
                                    >
                                        <template #prepend-content><CIcon name="cil-user" /></template>
                                    </CInput>
                                    <CInput
                                        v-model="password"
                                        placeholder="Пароль"
                                        type="password"
                                        autocomplete="curent-password"
                                        required
                                        @keyup.enter="login"
                                    >
                                        <template #prepend-content><CIcon name="cil-lock-locked" /></template>
                                    </CInput>
                                    <p v-if="error" class="pb-3" style="color: red">{{ error }}</p>
                                    <CRow>
                                        <CCol col="6" class="text-left">
                                            <CButton
                                                color="primary"
                                                class="px-4"
                                                @click="login">Войти</CButton>
                                        </CCol>
                                        <CCol col="6" class="text-right" />
                                    </CRow>
                                </CForm>
                            </CCardBody>
                        </CCard>
                    </CCardGroup>
                </CCol>
            </CRow>
        </CContainer>
    </div>
</template>

<script>
    import { AUTH_REQUEST } from '../../store/actions/auth';

    export default {
        name: 'Login',
        data() {
            return {
                email: '',
                password: '',
                error: ''
            };
        },
        methods: {
            login: function() {
                const this_ = this;
                const { email, password } = this;
                this.error = '';
                this.$store.dispatch(AUTH_REQUEST, { email, password })
                    .then( resp => {
                        if(resp.data.error) {
                            this_.error = resp.data.error;
                        } else {
                            this.$router.push('/');
                        }
                    })
                    .catch(err => {
                        this.error = err.message;
                    });
            }
        }
    }
</script>
